$(function () {
    var shouldShowPlaceholder = true;
    const player = $('#stream-player');
    const url = player.html();
    player.empty();
    const playerPlaceholder = $('#stream-player-placeholder');

    setTimeout(function () {
        if (shouldShowPlaceholder) {
            playerPlaceholder.children().first().removeClass('d-none');
        }
    }, 500);
    window.addEventListener('message', function (message) {
        if (!!message && !!message.data && !!message.data.method) {
            if (message.data.method === 'heightChanged') {
                player.css({
                    'padding-bottom': '0px',
                    height: message.data.height
                });
            }
            if (message.data.method === 'cookiesAccepted' && window.hasAcceptedCookieCategory('multimedia')) {
                shouldShowPlaceholder = false;
                player.append('<iframe width="100%"\n' +
                    'src="' + url + '"\n' +
                    'style="border: none; overflow: hidden;"\n' +
                    'height="100%"\n' +
                    'scrolling="no"\n' +
                    'frameBorder="0"\n' +
                    'allow="accelerometer; clipboard-write; encrypted-media; gyroscope; web-share; plays-inline; fullscreen; camera; microphone; geolocation; display-capture; speaker-selection;">\n' +
                    '</iframe>')
                playerPlaceholder.remove();
                player.removeClass('d-none');
            }
        }
    });
});
